export default __webpack_public_path__ + "static/media/Polymer_Logistics_6317.87fd14f2.jpg";